import React from 'react';

const TabsListLayout = ({ children }) => (
  <div className="ws-ui-tabs__tabs-list-layout">{children}</div>
);

export default TabsListLayout;
